import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import style from './style/footer.scss';

export default class Footer extends Component {
    render() {
        const {
            i18nParticipation,
            children,
            participantLanguage,
            branding = { logo: '', printLogo: '' },
            classes = { root: '' }
        } = this.props;

        return (
            <div className={ `${style.assessment_report_footer} ${classes.root}` }>
                <div className={ style.wrapper }>
                    <div className={ style.logo_container }>
                        { branding.logo ? <img src={ branding.logo ? branding.logo : '' } className={ style.logo } alt="LTP"/> : null }
                        { branding.printLogo ? <img src={ branding.printLogo ? branding.printLogo : '' } className={ style.printLogo } alt="LTP"/> : null }
                        <div className={ style.icons_container }>
                            <a href="https://www.facebook.com/ltp.nl/" target="_blank"><FontAwesomeIcon icon={ faFacebookF }/></a>
                            <a href="https://www.linkedin.com/company/ltp/" target="_blank"><FontAwesomeIcon icon={ faLinkedinIn }/></a>
                        </div>
                    </div>
                    <div>{ children }</div>
                    <div>
                        <a href={ participantLanguage === 'nl-NL'
                            ? 'https://www.ltp.nl/privacy_statement/nl/'
                            : 'https://www.ltp.nl/privacy_statement/en/' } className={ style.title } target="_blank">
                            { i18nParticipation.report_footer_privacy }
                        </a>
                    </div>
                    <div className={ style.contact_container }>
                        <p className={ style.title }>{ i18nParticipation.report_footer_contact }</p>
                        <p><FontAwesomeIcon icon={ faPhone } rotation={ 90 }/><a href="tel:0203050438">020 - 30 50 438</a></p>
                        <p><FontAwesomeIcon icon={ faEnvelope }/><a href="mailto:online@ltp.nl" target="_blank">online@ltp.nl</a></p>
                    </div>
                </div>
            </div>
        );
    }
}
